<template>
  <div id="totalizadores-mapa-sintetico">

    <div class="w3-container">
       <div class="w3-row w3-col  s12 m12 w3-right w3-margin-bottom">
      <div class="w3-col s12 item">
        <div style="background-color: #f5f5f5" class=" w3-padding w3-col">
          <div class="w3-col s12 m5 w3-large"><b>Saldo inicial</b></div>
          <div class="w3-col s12 m7 w3-large" style="text-align: right"><b> R$ {{ formatarValor(dados.total_saldos, 2) }}</b></div>
        </div>
        <div class="w3-col w3-hide-medium w3-hide-large" style="text-align: center"><i class="fa fa-plus"></i></div>
        <div class="bloco w3-col s12 m6" >
          <div class="w3-col s4 m5 w3-large">Contas a receber</div>
          <div class="w3-col s8 m7 w3-large" style="text-align: right;color:#2e6730" ><b>R$ {{ formatarValor(dados.total_contas_receber, 2) }}</b></div>
        </div>
        <div class="w3-col w3-hide-medium w3-hide-large" style="text-align: center"><i class="fa fa-plus"></i></div>
        <div class="bloco w3-col s12 m6 ">
          <div class="w3-col s4 m5 w3-large">Previsões de venda</div>
          <div class="w3-col s8 m7 w3-large" style="text-align: right;color:#2e6730"><b>R$ {{ formatarValor(dados.total_previsoes_venda, 2) }}</b></div>
        </div>
        <div class="w3-col w3-hide-medium w3-hide-large" style="text-align: center"><i class="fa fa-minus"></i></div>
        <div class="bloco w3-col s12 m6 ">
          <div class="w3-col s4 m5 w3-large">Contas a pagar</div>
          <div class="w3-col s8 m7 w3-large" style="text-align: right; color:#9c1d1c"><b> R$ {{ formatarValor(dados.total_contas_pagar, 2) }}</b></div>
        </div>
        <div class="w3-col w3-hide-medium w3-hide-large" style="text-align: center"><i class="fa fa-minus"></i></div>
        <div class="bloco w3-col s12 m6 ">
          <div class="w3-col s4 m5 w3-large">Previsões a pagar</div>
          <div class="w3-col s8 m7 w3-large" style="text-align: right ; color:#9c1d1c"><b> R$ {{ formatarValor(dados.total_previsoes_pagar, 2) }}</b></div>
        </div>
        <div class="w3-col w3-hide-medium w3-hide-large" style="text-align: center"><i class="fa fa-equals"></i></div>
        <div style="background-color: #f5f5f5" class=" w3-padding w3-col">
          <div class="w3-col s12 m7 w3-large"><b>Saldo no final do dia</b> <span class="w3-small w3-hide-small">(Saldo inicial + Contas a receber + Previsões de venda - Contas a pagar - Previsões a pagar)</span></div>
          <div class="w3-col s12 m5 w3-large" style="text-align: right"><b> R$ {{ formatarValor(dados.saldo_final, 2) }}</b></div>
        </div>
      </div>
      </div>
    </div>  
  </div> 
</template>

<script>
import formatarValorMixin from '@/mixins/formatarValorMixin.js'
export default {
  name: 'TotalizadoresMapaSintetico',
  props: ['dados'],
  mixins:[formatarValorMixin],
  data() {
    return {
      
    }
  },
  mounted() {
    $('html,body').stop().animate({
      scrollTop: 0
    }, 'slow', 'swing');
  },
}    
</script>

<style scoped>
.w3-card {
  padding: 10px;
  box-shadow: none !important;
}
  
  .item{
    border:1px solid #c6c6c6;
    border-radius: 10px;
    overflow:hidden;
    margin-bottom: 80px;
  }
  .bloco{
    padding: 5px 16px
  }

  @media screen and (max-width: 767px){    
    #totalizadores-mapa-sintetico .w3-container{
      padding: 0 !important
    }
    .item > div:first-of-type > div:first-of-type, .item > div:last-of-type > div:first-of-type{
      text-align: center !important;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/TotalizadoresMapaSintetico.vue